import {
  LearningPathCard
} from 'UI'
import { LearningPathRootPath } from 'navigation/Routes'
import style from './style.js'
import { createUseStyles } from 'react-jss'

const useStyle = createUseStyles(style)

export default ({
  learningPath,
  loading,
  handlePathClick,
  width,
  desktopWidth,
  tabletWidth,
  mobileWidth,
  margin,
  marginTablet,
  marginMobile,
  key
}) => {
  const { anchorClass } = useStyle({
    width,
    tabletWidth,
    mobileWidth,
    margin,
    marginTablet,
    marginMobile,
    desktopWidth
  })
  return (
    <a
      key={key}
      onClick={e => e.preventDefault()}
      name={learningPath?.Title}
      href={`${LearningPathRootPath}/${learningPath?.Slug}`}
      className={anchorClass}
    >
      <LearningPathCard
        loading={loading}
        title={learningPath?.Title}
        isNew={learningPath?.IsNew}
        duration={learningPath?.Duration}
        coursesCount={learningPath?.CountCourses}
        handleCardClick={() => handlePathClick(`${LearningPathRootPath}/${learningPath.Slug}`)}
        height={245}
      />
    </a>
  )
}
